import { render, staticRenderFns } from "./ShowSimulationExamsPage.vue?vue&type=template&id=7328fdd2&scoped=true&"
import script from "./ShowSimulationExamsPage.vue?vue&type=script&lang=js&"
export * from "./ShowSimulationExamsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowSimulationExamsPage.vue?vue&type=style&index=0&id=7328fdd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328fdd2",
  null
  
)

export default component.exports